export default __webpack_public_path__ + "static/media/light-theme-example.8db8d002.png";